import { useEffect, useState } from "react";
import { SuccessFetch } from "types";
import { useApi } from "utils";
import { PromiseToComeResponse } from "../../types";

type UsePromiseToCome = {
  location_id?: string;
  page?: number;
  limit?: number;
};

type PaginationType = {
  total: number
  page: number
  size: number
  pages: number
}

export const usePromiseToCome = ({ location_id, page, limit }: UsePromiseToCome) => {
  const api = useApi();
  const [data, setData] = useState<PromiseToComeResponse | null>(null);
  const [pagination, setPaginationData] = useState<PaginationType | null>(null);

  const params: Record<string, string | number> = {
    ...(location_id && { location_id }),
    ...(limit && { limit }),
    ...(page && { page }),
  };

  const fetchData = () => {
    api.get("/dasboard_inventory/po-promises-to-come", { params })
      .then((res: SuccessFetch<{ payload: PromiseToComeResponse, pagination_data: PaginationType }>) => {
        setPaginationData(res.data.pagination_data)
        setData(res.data.payload)
      })
      .catch(() => setData(null));
  };

  useEffect(() => {
    fetchData();
    return () => setData(null);

    // eslint-disable-next-line
  }, [location_id, page, limit]);

  const fetchAll = async () => {
    const res = await api.get(
      "/dasboard_inventory/po-promises-to-come",
      {
        params: {
          ...(location_id && { location_id }),
          page: 1,
          limit: -1
        }
      }
    );

    return res.data.payload as PromiseToComeResponse;
  };

  return { fetchData, data, pagination, fetchAll };
}
